// =====================================================================
// Formato de montos en pesos. Los montos se guardan con 2 decimales
// (numeric(12,2)) y pueden tener centavos (p.ej. facturas a obras
// sociales): se muestran SOLO cuando los hay, para no ensuciar los montos
// redondos ("$ 12.400" vs "$ 12.400,50"). Nunca se redondea a pesos.
// =====================================================================

const whole = new Intl.NumberFormat("es-AR", {
  style: "currency",
  currency: "ARS",
  maximumFractionDigits: 0,
});

const cents = new Intl.NumberFormat("es-AR", {
  style: "currency",
  currency: "ARS",
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

/** Redondea a centavos (evita arrastre de punto flotante: 0.1 + 0.2). */
export function roundCents(n: number): number {
  return Math.round(n * 100) / 100;
}

/** "$ 12.400" si es un monto entero; "$ 12.400,50" si tiene centavos. */
export function formatMoney(value: number | string | null | undefined): string {
  const n = typeof value === "string" ? Number(value) : (value ?? 0);
  if (!Number.isFinite(n)) return whole.format(0);
  const r = roundCents(n);
  return Number.isInteger(r) ? whole.format(r) : cents.format(r);
}

/** Misma interfaz que `Intl.NumberFormat` (`.format(n)`), para reemplazarlo directo. */
export const moneyFormatter = {
  format: (value: number | bigint) => formatMoney(Number(value)),
};

export type MoneyFormatter = typeof moneyFormatter;
